export default __webpack_public_path__ + "static/media/photo5.16f97acf.jpg";